import { render, staticRenderFns } from "./DraftOrderConfirmPage.vue?vue&type=template&id=09be877d&scoped=true&"
import script from "./DraftOrderConfirmPage.vue?vue&type=script&lang=js&"
export * from "./DraftOrderConfirmPage.vue?vue&type=script&lang=js&"
import style0 from "./DraftOrderConfirmPage.vue?vue&type=style&index=0&id=09be877d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be877d",
  null
  
)

export default component.exports